import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** clsx + tailwind-merge (same helper as Rise Up / GiveUp `src/lib/utils.ts`). */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
